const files = require.context("./views", true, /\.vue$/);
const modules = [];
files.keys().forEach((key) => {
  modules.push(files(key).default);
});
export default modules;
